import request from '@/utils/request'

// 查询养车无忧列表
export function listCarCarefree(query) {
  return request({
    url: '/carcarefree/carcarefree/list',
    method: 'get',
    params: query
  })
}

// 查询养车无忧分页
export function pageCarCarefree(query) {
  return request({
    url: '/carcarefree/carcarefree/page',
    method: 'get',
    params: query
  })
}

// 查询养车无忧详细
export function getCarCarefree(data) {
  return request({
    url: '/carcarefree/carcarefree/detail',
    method: 'get',
    params: data
  })
}

// 新增养车无忧
export function addCarCarefree(data) {
  return request({
    url: '/carcarefree/carcarefree/add',
    method: 'post',
    data: data
  })
}

// 修改养车无忧
export function updateCarCarefree(data) {
  return request({
    url: '/carcarefree/carcarefree/edit',
    method: 'post',
    data: data
  })
}

// 删除养车无忧
export function delCarCarefree(data) {
  return request({
    url: '/carcarefree/carcarefree/delete',
    method: 'post',
    data: data
  })
}
